/**
 * Social.
 *
 * @format
 */

import React from 'react';
import { safeCurrentLanguage } from '@services/drupal-services';
import Translate from '@components/translation/translate-text-wrapper';
import WeChatModal from './wechat';

interface SocialLinkProps {
  facebook: string;
  linkedIn: string;
}

/**
 * Social Buttons.
 *
 * @returns
 */
const Social = ({ follow = true }): JSX.Element => {
  if (safeCurrentLanguage() === 'fr-ca') {
    return;
  }

  const currentUrl = window.location.href;
  const followLinks: SocialLinkProps = {
    facebook: 'https://www.facebook.com/VarianMedicalSystems',
    linkedIn: 'https://www.linkedin.com/company/varian-medical-systems/',
  };

  const shareLinks: SocialLinkProps = {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`,
    linkedIn: `https://www.linkedin.com/shareArticle?url=${currentUrl}`,
  };

  const urls = follow ? followLinks : shareLinks;
  /**
   * Render.
   */
  return (
    <div className={`social ${follow ? 'follow' : 'social'}`}>
      <div className="social-title">
        <Translate useJson={false}>Connect with Us</Translate>
      </div>
      <div>
        {safeCurrentLanguage() !== 'zh-hans' && (
          <>
            <a href={urls.facebook} target="_blank" rel="noopener noreferrer">
              <i className="fab fa-facebook-f" />
              <span className="visually-hidden">Facebook</span>
            </a>
          </>
        )}

        <a href={urls.linkedIn} target="_blank" rel="noopener noreferrer">
          <i className="fab fa-linkedin-in" />
          <span className="visually-hidden">LinkedIn</span>
        </a>

        {safeCurrentLanguage() === 'zh-hans' && <WeChatModal />}
      </div>
    </div>
  );
};
export default Social;
